"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const heroAnimate = {
    init: function () {
        const container = document.querySelectorAll(".js-hero-animate");
        container.forEach((element) => {
            let words = element.getElementsByClassName("word");
            let index = 0; //will store the index of the currently displayed word;
            let paused = false;
            // A rudimentary animation playback toggle for user to stop the animation
            const togglePause = (_event) => (paused = !paused);
            element.addEventListener("click", togglePause);
            element.addEventListener("keypress", togglePause);
            if (words?.length) {
                //words[index].style.opacity = 1;
                const animateWordOut = (cw) => {
                    setTimeout(function () {
                        cw.className = "word out";
                    }, 80);
                };
                const animateWordIn = (nw) => {
                    setTimeout(function () {
                        nw.className = "word in";
                    }, 80);
                };
                const animateWordBehind = (nw) => {
                    nw.className = "word behind";
                };
                const changeWord = () => {
                    if (paused)
                        return;
                    let current = words[index];
                    let previous = index > 0 ? words[index - 1] : words[words.length - 1];
                    let newWord = index == words.length - 1 ? words[0] : words[index + 1];
                    animateWordOut(current);
                    animateWordIn(newWord);
                    animateWordBehind(previous);
                    //update index index.
                    index = index === words.length - 1 ? 0 : index + 1;
                };
                //changeWord(); //initial call
                setInterval(changeWord, 2000); //call every 4s bac
            }
        });
    },
};
exports.default = heroAnimate;
